import { useEffect, useState } from 'react'
import { useQuery } from 'packages/core'
import { Loader } from 'packages/eid-ui'
import { useAnonymousTranslations } from 'hooks'
import { MaintenancePage } from 'packages/eid-ui'
import moment from 'moment'
import i18n from 'i18next'
import config from 'config'
import { useAppState } from 'appContext'

const useLoadTranslations = () => {
    const RESOURCE_SET_NAME = 'ITShop'

    const query = useQuery()
    // eslint-disable-next-line
    const [{ debugLocalization: isLocalized }, dispatchAppState] = useAppState()

    const debugLocalization =
        query.get('debugLocalization') === 'true' || isLocalized

    const { data, isInitialLoading } = useAnonymousTranslations()

    const locale = config.FALLBACK_LOCALE

    useEffect(() => {
        i18n.changeLanguage(locale)
        moment.locale(locale)
    }, [locale])

    useEffect(() => {
        if (query.get('debugLocalization') === 'true') {
            dispatchAppState({
                type: 'SET_DEBUG_LOCALE',
                payload: true,
            })
        }
    }, [])

    // NOTE: Need to debug why we are setting state but not using that
    // eslint-disable-next-line
    const [resourceBundle, setResourceBundle] = useState(null)

    useEffect(() => {
        if (data) {
            const localeData = data.reduce((current, r) => {
                let keyToUse = r.key
                const parts = r.key.split('_')
                if (parts[0] === RESOURCE_SET_NAME) {
                    keyToUse = r.key.substring(RESOURCE_SET_NAME.length + 1)
                }

                if (debugLocalization) {
                    current[keyToUse] = r.key
                } else {
                    current[keyToUse] = r.translatedValue
                }

                return current
            }, {})

            i18n.addResourceBundle(locale, 'public', localeData)
            setResourceBundle(localeData)
        }
    }, [data, locale, debugLocalization])

    return { isReady: Boolean(data), isInitialLoading }
}

const withRequiredLocaleData = (ChildComponent) => (props) => {
    const { isInitialLoading, isReady } = useLoadTranslations()

    if (isInitialLoading) {
        return <Loader />
    }

    if (!isReady) {
        return (
            <MaintenancePage
                title="Under Maintenance "
                description="Making things better, please stand by."
                linkText="Take me to the home page"
            />
        )
    }

    return <ChildComponent {...props} />
}

export default withRequiredLocaleData
